import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, fetchBanner, downloadPDF } from './modules'
import Loading from 'components/Loading'
import { setCardResultVisible } from 'store/siteConfig'

export default function(route) {
  const Result = Loadable({
    loader: () => import('./Result'),
    render(loaded, props) {
      const Component = connect((state) => ({
        payPageResultState: state.payPageResultState,
        siteConfig: state.siteConfig
      }), {
        init,
        fetchBanner,
        downloadPDF,
        setCardResultVisible
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Result {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
